module.exports = __webpack_public_path__ + "static/media/adriane.6f891dd7.jpg";